import { render, staticRenderFns } from "./base-table.vue?vue&type=template&id=3d0bd1af"
import script from "./base-table.vue?vue&type=script&lang=js"
export * from "./base-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports